import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetDetailsBudget = createAsyncThunk(
  "DetailsBudget/GetDetailsBudget",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DetailsBudgetValues/GetDetailsBudget",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"app");
      return data; // Return the extracted data
      
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const DetailsBudgetReducers = createSlice({
  name: "DetailsBudgetReducers",
  initialState: {
    
    DetailsBudget: {},
    loadingDetailsBudget: false,
    errorDetailsBudget: null,
  },
  reducers: {},
  extraReducers: (builder) => {
   
      builder
        .addCase(GetDetailsBudget.pending, (state, action) => {
          state.loadingDetailsBudget = true;
          state.DetailsBudget = action.payload;
          state.errorDetailsBudget = null;
        })
        .addCase(GetDetailsBudget.fulfilled, (state, action) => {
          state.loadingDetailsBudget = false;
          state.DetailsBudget = action.payload; // Assuming payload has the desired data
        })
        .addCase(GetDetailsBudget.rejected, (state, action) => {
          state.loadingDetailsBudget = false;
          state.errorDetailsBudget = action.payload;
        });
  },
});

export default DetailsBudgetReducers.reducer;
